import { FormikConfig } from 'formik'
import { StudioSnippet, useCreateSnippet, useUpdateSnippet } from '@/features/snippets'
import { toastSuccess } from '@/utils/toast'
import { SnippetFormSchemaType } from './SnippetModal.types'

const NEW_SNIPPET_CODE = `// Welcome!
// Here you can add your snippet code`

export const useForm = (snippet: StudioSnippet | undefined, close: () => void): FormikConfig<SnippetFormSchemaType> => {
  const create = useCreateSnippet()
  const update = useUpdateSnippet(snippet?.id ?? 0)

  const initialValues = {
    name: snippet?.name ?? 'New snippet',
    description: snippet?.description ?? '',
    runtime: snippet?.runtime ?? 'nodejs',
    code: snippet?.code ?? NEW_SNIPPET_CODE,
  }

  const onSubmit = async (values: SnippetFormSchemaType) => {
    if (snippet) await update.mutateAsync(values)
    else await create.mutateAsync(values)

    close()
    toastSuccess(snippet ? 'Successfully updated the snippet' : 'Successfully created the snippet')
  }

  return { initialValues, onSubmit }
}

export const usePaste = (paste: (value: string) => void, close: () => void) => (value: string) => {
  paste(value)
  close()
}
